export default "__VITE_ASSET__UiM_$Rgm__"